module.exports = __webpack_public_path__ + "media/bootstrap-icons/triangle-2183a6eb.svg";